import { makeStyles } from '@mui/styles';
import { body2 } from '../../shared/theme/text.styles';

export const useJDStyles = makeStyles((theme) => ({
  jdResponsiblities: {
    listStyle: 'inside',
    listStyleType: 'decimal',
    marginBottom: '30px',
    ...body2,
  },

  jdQualifications: {
    padding: '0px',
    listStyle: 'inside',
    ...body2,
  },
}));
